if (window.matchMedia('(min-width: 990px)').matches) {
$(document).ready(function () {
  let activeValue = null;
  let hoverTimeout;

  function activateMenu(value) {
    activeValue = value;

    $('.subnav-content.dropdown-menu')
      .removeClass('is-active')
      .filter('[data-value="' + value + '"]')
      .addClass('is-active');
  }

  function deactivateMenu() {
    activeValue = null;
    $('.subnav-content.dropdown-menu').removeClass('is-active');
  }

  // Hover on main trigger
  $('.hoverelement').on('mouseenter', function () {
    clearTimeout(hoverTimeout);
    const value = $(this).data('value');
    activateMenu(value);
  });

  $('.hoverelement').on('mouseleave', function () {
    hoverTimeout = setTimeout(function () {
      if (!$('.subnav-content.dropdown-menu:hover').length) {
        deactivateMenu();
      }
    }, 150);
  });

  $('.subnav-content.dropdown-menu').on('mouseenter', function () {
    clearTimeout(hoverTimeout);
  });

  // Leaving dropdown panel
  $('.subnav-content.dropdown-menu').on('mouseleave', function () {
    hoverTimeout = setTimeout(function () {
      if (!$('.hoverelement:hover').length) {
        deactivateMenu();
      }
    }, 150);
  });
});

}

if (window.matchMedia('(max-width: 989px)').matches) {
  
$(document).ready(function () {

$('.menu-drawer__navigation .clickelement').on('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  const value = $(this).data('value');
  const $slider = $(this).closest('nav.menu-drawer__navigation');
  $slider.find('.subnav-content.dropdown-menu').removeClass('is-active');
  $slider.find('.subnav-content.dropdown-menu[data-value="' + value + '"]').addClass('is-active');
  $slider.find('ul.menu-drawer__menu').addClass('is-submenu-open');
  $(this).parents('.menu-drawer__navigation-container').addClass('activatedls');
});


$('.subnav-content.dropdown-menu .submenu-header').on('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  const $slider = $(this).closest('nav.menu-drawer__navigation');
  $slider.find('ul.menu-drawer__menu').removeClass('is-submenu-open');
    $slider.find('.subnav-content.dropdown-menu').removeClass('is-active');
  $(this).parents('.menu-drawer__navigation-container').removeClass('activatedls');
});



});

}
